import {useNavigate, useSearchParams} from "react-router-dom";
import RegistrationForm from "../forms/RegistrationForm";
import {firebaseCreateUser} from "../services/user";
import {useMemo} from "react";
import {useLocation} from "react-router";

const ConnectorRegistrationScreen = () => {

    const navigate = useNavigate();
    const location = useLocation();

    // once login succeeded:
    // if we have a from location in our Navigation string, redirect users there
    // if not, redirect them to the dashboard
    const redirectTo = useMemo<string>(() => location.state?.from?.pathname || "/dashboard", [location])

    let [searchParams] = useSearchParams();

    return (
        <RegistrationForm onSubmit={
            async (values) => await firebaseCreateUser({
                values: values,
                isConnector: false,
                inviteId: searchParams.get("inviteId"),
                onSuccess: () => navigate(redirectTo),
            })
        }/>
    )
}

export default ConnectorRegistrationScreen